module.exports = __webpack_public_path__ + "static/img/time.552afc4a.png";